import { render, staticRenderFns } from "./SharingPolicy.vue?vue&type=template&id=6cb2aedc"
import script from "./SharingPolicy.vue?vue&type=script&lang=js"
export * from "./SharingPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports